<template>
    <div>
        <ContentHeader />
		<div v-if="loading" class="loading">
			<div class="loader"></div>
			<img src="@/assets/img/logo.jpg" alt="logo" width="496" height="99" class="loaderLogo">
		</div>
          <div class="factoryBanner" data-aos="fade-out">
            <span>text</span>
          </div>
          <div class="factory-page ctInner">
            <section class="about-intro block">
              <h1 class="leadTitle" data-aos="fade-up">Our Factory <br> Powered by OTSTEC — Precision, Safety, and Reliability in Every Lift</h1>
              <p data-aos="fade-right">
                At <strong>Elemax-Tech Engineering</strong>, we take pride in delivering world-class elevator and escalator solutions — and that begins with our manufacturing partner, <strong>Huzhou OTSTEC Elevator Co., Ltd.</strong>, one of China’s most trusted and advanced elevator manufacturers.
              </p>
              <p data-aos="fade-left">
                All our lifts are designed and produced at <strong>OTSTEC’s state-of-the-art factory</strong> in <strong>Nanxun, Huzhou City, Zhejiang Province, China</strong>, where innovation meets engineering excellence. This partnership allows us to provide our clients with the same level of quality and reliability trusted around the world.
              </p>
            </section>

            <section class="factory-page factory-overview ctInner">
              <h2 data-aos="fade-up">Factory Overview</h2>
              <div class="col">
                <div class="left">
                  <figure>
                    <img src="@/assets/img/overview.png" alt="overview">
                  </figure>
                </div>
                <div class="right">
                  <p>OTSTEC’s production facility integrates:</p>
                  <ul>
                    <li><strong>Design, manufacturing, and assembly</strong> of passenger, panoramic, hospital, home, and freight elevators, as well as escalators and moving walkways.</li>
                    <li><strong>Advanced testing laboratories</strong> to ensure strict compliance with international standards (EN81, GB7588, ISO9001).</li>
                    <li><strong>Precision machinery</strong> and automated lines that guarantee consistent build quality and efficiency.</li>
                    <li><strong>Dedicated R&D teams</strong> continuously improving ride comfort, energy efficiency, and safety.</li>
                  </ul>
                </div>
              </div>
            </section>

            <section class="factory-page factory-installation ctInner">
              <h2 data-aos="fade-up">From Factory to Installation</h2>
              <div class="col flip">
                <div class="left">
                  <figure>
                    <img src="@/assets/img/install.png" alt="install">
                  </figure>
                </div>
                <div class="right">
                  <p>Every lift supplied by Elemax-Tech undergoes:</p>
                  <ul>
                    <li><strong>Custom Design –</strong> Tailored to each client’s specifications, building structure, and usage needs.</li>
                    <li><strong>Precision Manufacturing –</strong> Built using high-grade materials and world-class components at OTSTEC’s facility.</li>
                    <li><strong>Quality Inspection –</strong> Thoroughly tested before shipping to ensure safe and smooth operation.</li>
                    <li><strong>Professional Installation –</strong> Installed and commissioned by Elemax-Tech’s skilled engineers.</li>
                    <li><strong>After-Sales Support –</strong>Regular maintenance, inspection, and service to keep your system running perfectly.</li>
                  </ul>
                </div>
              </div>
            </section>

            <section class="slider-wrapper type2" data-aos="fade-up">
              <VueSlickCarousel :arrows="true" :dots="true" :autoplay="true" :infinite="true" :slidesToShow="4" :slidesToScroll="1" :responsive="[{ breakpoint: 768, settings: { centerMode: true, centerPadding: '20%', slidesToShow: 1 } }]">
                <div v-for="(image, index) in images" :key="index" class="slide">
                  <img :src="image" alt="" />
                </div>
              </VueSlickCarousel>
            </section>
            
            <section class="factory-page factory-commitment ctInner">
              <h2 data-aos="fade-up">Our Commitment</h2>
              <div class="col">
                <div class="left">
                  <figure>
                    <img src="@/assets/img/commitment.png" alt="commitment">
                  </figure>
                </div>
                <div class="right">
                  <p>Together with OTSTEC, Elemax-Tech Engineering is committed to providing:</p>
                  <ul>
                    <li>Superior lift performance and durability</li>
                    <li>Modern design options for both commercial and residential applications</li>
                    <li>Energy-efficient, environmentally friendly technology</li>
                    <li>Reliable local installation and maintenance support</li>
                  </ul>
                </div>
              </div>
            </section>

            <section class="factory-page factory-partner ctInner">
              <h2 data-aos="fade-up">A Partnership You Can Trust</h2>
              <div class="col flip">
                <div class="left">
                  <figure>
                    <img src="@/assets/img/partner.png" alt="partner">
                  </figure>
                </div>
                <div class="right">
                  <p>By partnering with OTSTEC, Elemax-Tech bridges international manufacturing excellence with local engineering expertise.</p>
                  <p>From <strong>factory to final installation</strong>, we ensure every lift system delivers <strong>comfort, safety, and long-term reliability</strong> — the hallmarks of our service promise.</p>
                </div>
              </div>
            </section>

            <section class="slider-wrapper type2" data-aos="fade-up">
              <h2 data-aos="fade-up">Shipping</h2>
              <VueSlickCarousel :arrows="true" :dots="true" :autoplay="true" :infinite="true" :slidesToShow="4" :slidesToScroll="1" :responsive="[{ breakpoint: 768, settings: { centerMode: true, centerPadding: '20%', slidesToShow: 1 } }]">
                <div v-for="(image, index) in images2" :key="index" class="slide">
                  <img :src="image" alt="" />
                </div>
              </VueSlickCarousel>
            </section>
          </div>
        <ContentFooter />
    </div>
</template>

<script>
  import ContentHeader from '@/components/ContentHeader.vue'
  import ContentFooter from '@/components/ContentFooter.vue'
  import VueSlickCarousel from 'vue-slick-carousel';
  export default {
    name: 'FactoryPage',
    components: {
      ContentHeader,
      ContentFooter,
      VueSlickCarousel
    },
    data() {
      return {
        images: [
          require('@/assets/img/workshop1.webp'),
          require('@/assets/img/workshop2.webp'),
          require('@/assets/img/workshop3.webp'),
          require('@/assets/img/workshop4.webp'),
          require('@/assets/img/workshop5.webp'),
          require('@/assets/img/workshop6.webp')
        ],
        images2: [
          require('@/assets/img/shipping1.webp'),
          require('@/assets/img/shipping2.webp'),
          require('@/assets/img/shipping3.webp'),
          require('@/assets/img/shipping4.webp'),
          require('@/assets/img/shipping5.webp')
        ],
		loading: true,
      };
    },
	mounted() {
		this.loading = false;
	}
  }
</script>